import { ACT_CATALOG_DATA } from './catalog-data.js';
import { ActCatalogSchema, type ActCatalogEntry } from './index.js';

/**
 * Canonical flat act registry.
 *
 * Parsing on module load makes authored drift fail immediately for every
 * consumer. This expansion-phase export is additive: Word and Web still read
 * their historical catalogues until their dedicated migration slices land.
 */
export const ACT_CATALOG: readonly ActCatalogEntry[] = ActCatalogSchema.parse(ACT_CATALOG_DATA);
